/* unplugin-vue-components disabled */import { render } from "./FullScreenBar.vue?vue&type=template&id=ae159732"
const script = {}

import exportComponent from "E:\\projects\\internation-fta-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__